import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ListAnimation from '@/checkout-instore-legacy/cart/components/ProductList/ListAnimation'

import { getSlaObj } from '@vtex/delivery-packages/dist/sla'
import { usingMultiSeller } from '@/checkout-instore-legacy/seller/utils'

import {
  getOrderAsPackages,
  validatePackagesWithValidSlas,
} from '@/checkout-instore-legacy/shipping/utils'

import {
  getPackagesWithHeaderIndexing,
  calculateSellerAccountByPackage,
} from '@/checkout-instore-legacy/package/utils'

import { DEFAULT_GROUP_PACKAGE_OPTIONS } from '../../constants'
import { groupItemsWithAssemblyItems } from '@/checkout-instore-legacy/order/utils/groupItemsWithAssemblyItems'
import { isEmpty } from 'ramda'

class PackageSelector extends Component {
  render() {
    const {
      order,
      className,
      itemsClassName,
      headerClassName,
      packageClassName,
      reversedOrder,
      editable,
      packageOptions,
      packageCallback,
      children,
      header,
      setOrderPlacedInfo,
    } = this.props

    let packages = getOrderAsPackages(
      order,
      packageOptions
    ).map((pkg, index) => ({ ...pkg, index }))

    const invalidPackages = validatePackagesWithValidSlas(packages)

    const invalidPackagesIndexes = invalidPackages.map((pkg) => pkg.index)

    if (!packages || packages.length === 0) {
      return null
    }

    packages = packageCallback ? packageCallback(packages) : packages
    packages = getPackagesWithHeaderIndexing(packages)

    if (usingMultiSeller()) {
      packages = calculateSellerAccountByPackage(order, packages)
    }

    const numOfPackages = packages.length

    const filteredPackages = packages.map((pkg) => {
      const filteredItems = pkg.items.filter(
        (item) => item.parentItemIndex === null
      )

      return {
        ...pkg,
        items: filteredItems,
      }
    })

    const filteredPackagesWithoutEmptyItems = filteredPackages.filter(
      (filteredPackage) => {
        return !isEmpty(filteredPackage.items)
      }
    )
    const assemblyItems = groupItemsWithAssemblyItems(order.items)

    const assemblyItemsIsEmpty = isEmpty(assemblyItems[0]?.assemblyItems)

    const packagesToRender = assemblyItemsIsEmpty
      ? packages
      : filteredPackagesWithoutEmptyItems

    return (
      <div id="package-of-items" className={className}>
        {packagesToRender.map((pkg) => {
          let { items } = pkg
          const { index } = pkg

          if (reversedOrder) {
            items = items.slice().reverse()
          }

          pkg.selectedSlaObj = getSlaObj(pkg.slas, pkg.selectedSla)
          pkg.isValid = invalidPackagesIndexes.indexOf(index) === -1

          const headerProps = {
            pkg,
            numOfPackages,
            className: headerClassName,
            order,
            setOrderPlacedInfo,
          }

          const content = items.map((item, orderIndex) => {
            const isLastOfPackage = orderIndex === items.length - 1
            return children && children(item, item.index, isLastOfPackage)
          })

          const contentAssemblyItems = assemblyItems.flatMap(
            (assemblyItem, orderIndex) => {
              const isLastOfPackage = orderIndex === order.items.length - 1

              const contentOrderFormItem = children(
                assemblyItem.orderFormItem.item,
                assemblyItem.orderFormItem.item.index,
                isLastOfPackage
              )

              const contentAssemblyItems = assemblyItem.assemblyItems.map(
                (assembly, index) => {
                  const isLastOfPackage2 = index === order.items.length - 1

                  return children(
                    assembly.item,
                    assembly.index,
                    isLastOfPackage2
                  )
                }
              )

              return [contentOrderFormItem, ...contentAssemblyItems]
            }
          )

          return (
            <div
              id={`pkg-selector-header-container-${index + 1}`}
              key={pkg.selectedSla}
              className={packageClassName}
            >
              {numOfPackages > 0 &&
                header &&
                React.cloneElement(header, headerProps)}
              <div className={`${itemsClassName}`}>
                {editable ? (
                  <>
                    <ListAnimation>
                      {assemblyItemsIsEmpty ? content : contentAssemblyItems}
                    </ListAnimation>
                  </>
                ) : assemblyItemsIsEmpty ? (
                  content
                ) : (
                  contentAssemblyItems
                )}
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

PackageSelector.defaultProps = {
  className: '',
  itemsClassName: 'bg-base bt b--black-20',
  packageClassName: 'br3 mb5 bb b--black-10',
  reversedOrder: false,
  packageOptions: DEFAULT_GROUP_PACKAGE_OPTIONS,
}

PackageSelector.propTypes = {
  heading: PropTypes.node,
  order: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  itemsClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  packageClassName: PropTypes.string,
  packageOptions: PropTypes.object,
  packageCallback: PropTypes.func,
  reversedOrder: PropTypes.bool,
  editable: PropTypes.bool,
  setOrderPlacedInfo: PropTypes.func,
}

export default PackageSelector
